// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"447":"component-lazy","741":"side-panel-card-lazy"}[chunkId] || chunkId) + "." + {"447":"d16c4d5322de035bc332","741":"b7eb45aad272f6ab6a56","898":"23dce5a3575e5f2735b5"}[chunkId] + ".js";
};